import { HolidayTypes } from 'enums';
import { DaysFree } from 'store/bankHolidays/bankHolidays';
import { Holiday } from 'store/holidays/interfaces';

const workingHoursInDay = 8;

interface GetHolidaysHours {
  bankHolidays: DaysFree[];
  employeeHolidays: Holiday[];
  displayedYear: number;
  startOfWeek: Date;
  endOfWeek: Date;
}

export default function getHolidaysHours({
  bankHolidays,
  employeeHolidays,
  displayedYear,
  startOfWeek,
  endOfWeek,
}: GetHolidaysHours) {
  const noRemoteEmployeeHolidays = employeeHolidays.filter(
    (holiday) => holiday.type !== HolidayTypes.remote,
  );

  const convertedBankHolidays = bankHolidays.map(({ date }) => {
    const dateWithYear = date.replace('*', String(displayedYear));
    return new Date(dateWithYear);
  });

  const bankHolidaysInRange = convertedBankHolidays.filter(
    (holiday) => holiday >= startOfWeek && holiday <= endOfWeek,
  );

  const noRemoteEmployeeHolidaysDuration = noRemoteEmployeeHolidays.reduce(
    (acc, holiday) =>
      acc + (holiday.hours ? holiday.hours : holiday.requestedDays * workingHoursInDay),
    0,
  );
  const bankHolidaysDuration = bankHolidaysInRange.length * workingHoursInDay;

  return noRemoteEmployeeHolidaysDuration + bankHolidaysDuration;
}
